/* Angular Component */
import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  FilterBlock,
  FilterBlockOperator,
  FilterTerm,
} from "../../../domain/visual-filters";
import { Observable } from "rxjs/internal/Observable";
import { Subscription } from "rxjs/internal/Subscription";

@Component({
  selector: "visual-filter",
  templateUrl: "visual-filter.component.html",
  styleUrls: ["./visual-filter.component.scss"],
})
export class VisualFilterComponent {
  vm: Array<FilterBlock>;
  operators = FilterBlockOperator;
  private clearSearchSubscription: Subscription;

  @Input()
  terms: Array<FilterTerm> = [];

  @Input() clearSearch: Observable<void>;

  @Input() onlyAndStatement = true;

  @Output() filterChanged = new EventEmitter();
  @Output() enterPressed = new EventEmitter();

  ngOnInit() {
    this.initVm();
    this.clearSearchSubscription = this.clearSearch.subscribe(
      this.initVm.bind(this),
    );
  }
  ngOnDestroy() {
    this.clearSearchSubscription.unsubscribe();
  }

  initVm() {
    this.vm = [
      {
        statement: "AND",
        term: "any",
        operator: FilterBlockOperator.Equal,
        value: "",
      },
    ];
    this.updateFiltersState();
  }

  termHasOptions(id: string) {
    let term = this.terms.find((x) => x.id == id);
    if (!term) {
      return false;
    }
    return term.options && term.options.length > 0;
  }
  termGetOptions(id: string) {
    return this.terms.find((x) => x.id == id).options;
  }

  addFilterRow() {
    let last = this.vm[this.vm.length - 1];
    if (last.term) {
      this.vm.push({
        statement: "AND",
        term: null,
        operator: FilterBlockOperator.Equal,
        value: "",
      });
    }
  }
  removeFilterRow(index) {
    if (index > 0) {
      this.vm.splice(index, 1);
    }
    this.updateFiltersState();
  }
  updateRowInputValue(index, value) {
    this.vm[index].value = value;
    this.updateFiltersState();
  }
  onKeypressEvent(event: KeyboardEvent) {
    if (event.key == "Enter") {
      setTimeout(() => {
        this.enterPressed.emit(this.vm);
      }, 100);
    }
  }
  updateFiltersState() {
    this.filterChanged.emit(this.vm);
  }
  onEnterPressed() {
    this.enterPressed.emit(this.vm);
  }
}
